{
    "title": "autobrr",
    "username": "Uživatelské jméno",
    "password": "Heslo",
    "confirmPassword": "Potvrď heslo",
    "createAccount": "Vytvoř účet",
    "rememberMe": "Zapamatuj si mě",
    "forgotPassword": "Zapomenuté heslo?",
    "forgotPasswordHelp": "Vyresetovat heslo přes terminál:",
    "signIn": "Přihlásit se",
    "continueWith": "Nebo pokračuj s",
    "openidConnect": "OpenID Connect",
    "errors": {
      "required": "Povinné",
      "usernameRequired": "Uživatelské jméno je povinné",
      "passwordRequired": "Heslo je povinné",
      "passwordsDoNotMatch": "Hesla se neshodují!",
      "generic": "Došlo k chybě!",
      "oidcFailed": "OIDC autentizace selhala"
    }
  }
